.root {
  background-color: light-dark(var(--mantine-color-white), var(--mantine-color-primaryDark-8));
  transition: none !important;

  &[data-variant="dashed"] {
    background-color: transparent;
    border: calc(0.0625rem * var(--mantine-scale)) dashed
      light-dark(var(--mantine-color-gray-3), var(--mantine-color-primaryDark-7));
    border-radius: var(--mantine-radius-default);
    box-shadow: none;
  }
}
